import React from 'react'
import { injectState, provideState } from 'freactal'
import styled from 'styled-components'
import Collapse from 'react-collapse'
import { Icon, IconButton } from 'react-mdl'
import ReportErrorButton from './ReportErrorButton'

const Container = styled.div`
  background-color: rgba(255, 0, 0, 0.25);
  border: 1px solid red;
  border-radius: 0.5em;
  padding: 0.25em;
  color: red;
`
const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`
const Stack = styled.div`
  position: relative;
  border: 1px solid rgba(255, 0, 0, 0.25);
  min-height: 32px;
`

const withState = provideState({
  initialState: () => ({
    stackOpen: false,
  }),
  effects: {
    toggleStackOpen: () => ({ stackOpen }) => ({ stackOpen: !stackOpen }),
  },
})

function DisplayError({
  msg,
  error,
  errorContext,
  state: { stackOpen },
  effects: { toggleStackOpen },
}) {
  if (!error) return null
  let additionalInformation = ''
  const errorMessage = `${error.type} - ${error.name} - ${error.message}`
  // handle key-based error messages from mongoose validation
  if (error.errors) {
    for (const [key, { errors }] of Object.entries(error.errors)) {
      additionalInformation += `- "${key}": ${errors.items.message}`
    }
  }
  return (
    <Container>
      <SpaceBetween>
        <Icon name="error" />
        <ReportErrorButton error={error} errorContext={errorContext} />
      </SpaceBetween>
      {msg && <p>{msg}</p>}
      <p>{errorMessage}</p>
      {additionalInformation && <p>{additionalInformation}</p>}
      {error.stack &&
        <Stack>
          <Collapse isOpened={stackOpen}>
            <p>{error.stack}</p>
          </Collapse>
          <IconButton
            style={{ position: 'absolute', top: 0, right: 0 }}
            name={stackOpen ? 'remove' : 'add'}
            onClick={toggleStackOpen}
          />
        </Stack>}
    </Container>
  )
}

export default withState(injectState(DisplayError))



// WEBPACK FOOTER //
// ./src/components/DisplayError.js